/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResultRepresentation
 */
export interface ResultRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ResultRepresentation
     */
    contentType?: string;
    /**
     * The actual result payload, structure depends on jobType
     * @type {object}
     * @memberof ResultRepresentation
     */
    payload?: object;
}

/**
 * Check if a given object implements the ResultRepresentation interface.
 */
export function instanceOfResultRepresentation(value: object): value is ResultRepresentation {
    return true;
}

export function ResultRepresentationFromJSON(json: any): ResultRepresentation {
    return ResultRepresentationFromJSONTyped(json, false);
}

export function ResultRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'payload': json['payload'] == null ? undefined : json['payload'],
    };
}

export function ResultRepresentationToJSON(json: any): ResultRepresentation {
    return ResultRepresentationToJSONTyped(json, false);
}

export function ResultRepresentationToJSONTyped(value?: ResultRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contentType': value['contentType'],
        'payload': value['payload'],
    };
}

